class PaintBrush {
    public thickness: number;
    public color: number;
    public alpha: number;

    constructor() {
        this.thickness = 20;
        this.color = 0xFFFF00;
        this.alpha = 1;
    }
}


export class MainScene extends Phaser.Scene {
    private easel: Phaser.GameObjects.Image;
    private easelControls: Phaser.GameObjects.Image;
    private coins: Phaser.GameObjects.GameObject[] = [];

    private paintBrush: PaintBrush = new PaintBrush();

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("background", require("/src/assets/games/coinRunner/background.png"));
        this.load.image("control-background", require("/src/assets/phaser-assets/textures/wood_by_EricHart3d.png"));
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
    }
    create(): void {
        // Generate Easel
        // Generate Control area
        // Generate Controls
        // Wire up events, include the 'options'

        // START!!!
        // var gameWidth = (this.textures.game.config as GameConfig).width as number;
        // var gameHeight = (this.textures.game.config as GameConfig).height as number;
        var easelArea = { width: 600, height: 600 };
        var controlArea = { width: 200, height: 600 };

        // Generate Easel
        this.easel = this.add.image(0, 0, "background");
        this.easel.setOrigin(0, 0);
        this.easel.setScale(easelArea.width / this.easel.width, easelArea.height / this.easel.height);
        this.easel.setSize(easelArea.width, easelArea.height);
        this.easel.depth = -1;

        // Generate Control area
        this.easelControls = this.add.image(easelArea.width, 0, "control-background");
        this.easelControls.setOrigin(0, 0);
        this.easelControls.setScale(controlArea.width / this.easelControls.width, controlArea.height / this.easelControls.height);
        this.easelControls.setSize(controlArea.width, controlArea.height);
        this.easelControls.depth = 1;

        // Generate Controls
        // this.add.image(100, 400, 'atlas', 'supercars-parsec');

        // Auto generate based on colors
        var colors = [0xffff00, 0xf46842, 0x77f441, 0x419df4];
        var buttonSize = { height: 75, width: 75 };
        var yCoord = 200;
        for (const color of colors) {
            var button = this.add.image(this.easelControls.x, yCoord, "pixel");
            button.setOrigin(0);
            button.setDepth(1);
            button.setInteractive();
            button.setTint(color);
            button.setDisplaySize(buttonSize.width, buttonSize.height);
            button.on("pointerdown", () => {
                var _color = color;
                this.paintBrush.color = _color;
                graphics.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
                graphics.fillStyle(this.paintBrush.color, this.paintBrush.alpha);
            });

            yCoord += 75;
        }

        // Generate Paint Layer
        var graphics = this.add.graphics();
        graphics.setPosition(0, 0);
        var previousLocation = { x: 0, y: 0 };
        graphics.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
        graphics.fillStyle(this.paintBrush.color, this.paintBrush.alpha);

        // Paint Events
        var draw = false;
        this.input.on('pointerdown', function (pointer: Phaser.Input.Pointer) {
            // Figure out if we are in the easel before we start drawing
            previousLocation = { x: pointer.x, y: pointer.y };
            graphics.fillCircleShape(new Phaser.Geom.Circle(pointer.x, pointer.y, 2));
            // graphics.strokeLineShape(new Phaser.Geom.Line(previousLocation.x, previousLocation.y, pointer.x, pointer.y));
            draw = true;
        });
        this.input.on('pointerup', function () {
            draw = false;
        });
        this.input.on('pointermove', function (pointer: Phaser.Input.Pointer) {
            if (draw) {
                graphics.strokeLineShape(new Phaser.Geom.Line(previousLocation.x, previousLocation.y, pointer.x, pointer.y));
                previousLocation = { x: pointer.x, y: pointer.y };
            }
        });
        // graphics.clear();
        // generate a line from the previous location?
        // var t = new Phaser.Geom.Line(pointer.downX, pointer.downY, pointer.x, pointer.y);
        // graphics.strokeRect(previousLocation.x, previousLocation.y, pointer.x - pointer.downX, pointer.y - pointer.downY);
    }

    update(): void {
        // Update on screen objects
        // this.item.update();
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserComplexPaintDemo/scenes/MainScene.ts